<template>
  <div class="step">
    <h4>Step {{number}} out of {{total}}</h4>
    <h2>{{step}}</h2>
  </div>
</template>

<script>
export default {
  props: ["number", "total", "step"]
};
</script>

<style lang="less" scoped>
  .step {
    text-align: center;
    width: 100%;

    h2{
      opacity: .8;
      color: black;
    }
    h4 {
      opacity: .6;
    }
  } 
</style>

